import { Component, inject, Input } from '@angular/core';
import { UserItemDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-user-badge',
  templateUrl: './user-badge.component.html',
  styleUrls: ['./user-badge.component.scss']
})
export class UserBadgeComponent {
  readonly router = inject(Router);

  @Input()
  @Tracked()
  user?: UserItemDto;

  @Input()
  @Tracked()
  disableLink = false;
}
